import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import Button from '../../shared/buttons/Button';
import TeamInvitationsForm from './components/TeamInvitationsForm';
import ErrorMessage from '../../shared/message/ErrorMessage';
import AlertMessage from '../../shared/message/AlertMessage';
import Table from '../../shared/table/Table';
import config from '../../config';

const columns = [
  {
    id: 'email',
    title: 'Email',
  },
  {
    id: 'created',
    title: 'Date sent',
    type: 'date',
  },
  {
    id: 'expire_time',
    title: 'Expires',
    type: 'date',
  },
  {
    id: 'resend',
    title: '',
  },
  {
    id: 'delete',
    title: '',
  },
];

class TeamInvitationsPage extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.updateEmailText = this.updateEmailText.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.saveInvitations = this.saveInvitations.bind(this);
    this.cancelInvite = this.cancelInvite.bind(this);
    this.resendInvite = this.resendInvite.bind(this);
    this.loadInvitations = this.loadInvitations.bind(this);
    this.getPlanDetails = this.getPlanDetails.bind(this);
    this.closeCancelInvitationModal = this.closeCancelInvitationModal.bind(this);
    this.updateActiveGroup = this.updateActiveGroup.bind(this);

    this.onSelectPageSize = this.onSelectPageSize.bind(this);
    this.onSelectPage = this.onSelectPage.bind(this);
    this.onRowSave = this.onRowSave.bind(this);
  }

  componentDidMount() {
    this.loadInvitations(this.props.team);
    this.getPlanDetails(this.props.team);
  }

  componentDidUpdate(prevProps, prevState) {
    const isDifferentTeam = this.props.team && (!prevProps.team || prevProps.team.id !== this.props.team.id);
    if (isDifferentTeam) {
      this.loadInvitations(this.props.team);
      this.getPlanDetails(this.props.team);
    }
  }

  /*
  componentWillReceiveProps(newProps) {

    const groups = newProps.groups;
    this.props.set({ groups });

    if (newProps.team.id !== this.props.team.id) {
      this.props.set({ team: newProps.team });
      this.loadInvitations(newProps.team);
      this.getPlanDetails(newProps.team);
    }

    if (newProps.division && this.props.division && newProps.division.id !== this.props.division.id) {
      this.props.set({ division: newProps.division });
    }
  }*/

  getPlanDetails(team) {
    this.props.getPlanDetails(team, config);
  }

  loadInvitations(team) {
    this.props.loadInvitations(team, this.props.resendInvite, this.showCancelInvitationModal);
  }

  openModal() {
    this.props.set({ modalIsOpen: true });
  }

  closeModal() {
    this.props.set({ modalIsOpen: false });
  }

  cancelInvite() {
    this.props.deleteInvitation(this.props.team, this.props.inviteId, config);
  }

  resendInvite(invitation) {
    this.props.resendInvite(this.props.team, invitation);
  }

  updateFormField(event) {
    let form = this.props.form;
    form[event.target.name] = event.target.value;
    return this.props.set({ form });
  }

  updateEmailText(event) {
    return this.props.set({ emailText: event.target.value });
  }

  saveInvitations(event) {
    event.preventDefault();
    this.props.saveInvitations(this.props.team, this.props.division, this.props.emailText, this.props.groupId, config);
    const trim = this.props.emailText.replace(/\s/g, '');
    const emails = trim.split(',');
    const length = emails.length + (this.props.members || []).length + (this.props.invitations || []).length;
    //this.props.googleTagManager.tagSub(this.props.team.id, this.props.subscription, null, length);
  }

  showCancelInvitationModal(inviteId) {
    this.props.set({ showCancelInvitation: false, inviteId: inviteId });
  }

  closeCancelInvitationModal() {
    this.props.set({ showCancelInvitation: false, inviteId: '' });
  }

  updateActiveGroup(event) {
    this.props.set({ groupId: event.id });
  }

  onSelectPageSize(pageSize) {}

  onSelectPage(page) {}

  onRowSave(index, row) {}

  render() {
    const hasPermission = this.props.checkPlanPermission('team_management') || false;
    let invitations = this.props.invitations;

    const parentSelector = () => document.querySelector('.main-content-container');
    const bulkActions = [
      {
        text: 'Delete selected',
        hasPermission,
        className: ' danger',
        onClick: (invites) => {
          this.props.deleteInvitations(this.props.team, invites, config);
        },
      },
      {
        text: 'Invite members',
        hasPermission,
        bypassCheck: true,
        onClick: (users) => {
          this.openModal();
        },
      },
    ];

    return (
      <div className="team-invitation-page">
        <ErrorMessage error={this.props.error} />
        <Modal
          className="hc-modal-content hc-modal-team-invite"
          overlayClassName="hc-modal-overlay"
          parentSelector={parentSelector}
          appElement={document.querySelector('.page-container')}
          isOpen={this.props.modalIsOpen}
          contentLabel="Example Modal"
          onRequestClose={this.closeModal}
        >
          <TeamInvitationsForm
            value={this.props.emailText}
            onSave={this.saveInvitations}
            onChange={this.updateEmailText}
            onClose={this.closeModal}
            groups={this.props.groups}
            groupId={String(this.props.groupId)}
            updateActiveGroup={this.updateActiveGroup}
            inviteError={this.props.inviteError}
            priceTotal={this.props.priceTotal / 100}
            unitPrice={this.props.unitPrice / 100}
            subscription={this.props.subscription}
          />
        </Modal>

        <Modal
          className="hc-modal-content"
          overlayClassName="hc-modal-overlay"
          appElement={document.querySelector('.page-container')}
          parentSelector={parentSelector}
          isOpen={this.props.showCancelInvitation}
          onRequestClose={this.closeCancelInvitationModal}
          contentLabel="Delete"
        >
          <p>Are you sure you want to cancel this invitation?</p>
          <Button buttonText="Yes" buttonClass="btn-primary" onClick={this.cancelInvite} />{' '}
          <Button buttonText="Cancel" buttonClass="btn-secondary" onClick={this.closeCancelInvitationModal} />
        </Modal>

        <div className="row no-margin-horizontal">
          <div className="col-sm-12 invitations-page-container">
            <h3>Invitations</h3>
            <p>Invite users by email address to your team to start collaborating.</p>
          </div>
        </div>

        <div className="content">
          {this.props.resend && <AlertMessage type="success" tag="Success" text="Email Sent" />}

          {invitations && (
            <Table
              columns={columns}
              rows={invitations}
              onRowSave={this.onRowSave}
              onSelectPageSize={this.onSelectPageSize}
              onSelectPage={this.onSelectPage}
              page={this.props.page}
              pageCount={this.props.pageCount}
              pageSize={this.props.pageSize}
              dataReturned={this.props.dataReturned}
              pagePosition={'bottom'}
              bulkActions={bulkActions}
              className={'page-bottom'}
            />
          )}
        </div>
      </div>
    );
  }
}

TeamInvitationsPage.propTypes = {
  team: PropTypes.object.isRequired,
  groups: PropTypes.array,
  division: PropTypes.object,
};

export default TeamInvitationsPage;
